import axios from 'axios';

const AxioslibApi = axios.create({
    baseURL: process.env.REACT_APP_API_CLOUD_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default AxioslibApi;